define([
    "./logRecordModule",
    "./logRecordRouter",
    "./logRecordController"
], function () {
});